// extracted by mini-css-extract-plugin
export default {"container":"EmptyVeille_container__C0Ho6","text":"EmptyVeille_text__H8t3L","pulse":"EmptyVeille_pulse__iOOBp"};